import React from "react";
import { PageBuilderProvider } from "./PageBuilderProvider";
import "./grid.scss";
import { PageBuilderSettings } from "./PageBuilderSettings";

export const PageBuilder = () => {
  return (
    <PageBuilderProvider>
      <PageBuilderSettings />
    </PageBuilderProvider>
  );
};
